import { ErrorIcon } from '../../../../../assets/icons/ErrorIcon';
import { SuccesIcon } from '../../../../../assets/icons/SucessIcon';
import { WarnIcon } from '../../../../../assets/icons/WarnIcon';

type ToastProps = {
  typeMessage: string;
  message: string;
  onClose?: (action: 'open' | 'close', message?: string) => Promise<void>;
};

export const Toast = ({ typeMessage, message, onClose }: ToastProps) => {
  const handleTypeMessage = () => {
    let background;
    let icon;

    switch (typeMessage) {
      case 'error':
        background = 'tw-bg-[#FACED2]';
        icon = <ErrorIcon />;
        break;

      case 'warn':
        background = 'tw-bg-[#F6E7B1]';
        icon = <WarnIcon />;
        break;

      case 'success':
        background = 'tw-bg-[#C5E7C9]';
        icon = <SuccesIcon />;
        break;

      default:
        background = 'tw-bg-gray-300';
        icon = '';
        break;
    }

    const result = {
      background,
      icon
    };
    return result;
  };

  return (
    <div
      className={`tw-w-full tw-max-w-[328px] md:tw-max-w-[906px] tw-flex tw-justify-center tw-items-center tw-gap-[10px] tw-fixed tw-top-[10px] md:tw-top-16 tw-left-[16px] md:tw-left-[20%] ${
        handleTypeMessage().background
      } tw-py-[20px] tw-rounded-[12px] tw-shadow-lg`}
    >
      <span>{handleTypeMessage().icon}</span>
      {message}
      {/* <span onClick={() => onClose('close')}>
        <CloseIcon />
      </span> */}
    </div>
  );
};
